export const prefix = '/api/v1/marketing';
export const mockPrefix = '/mock/v1/opinion-marketing';
